import { BackgroundVideoType } from 'types'

import video_a from './a.mp4'
import video_b from './b.mp4'
import video_c from './c.mp4'
import img_a from './a.jpg'
import img_b from './b.jpg'
import img_c from './c.jpg'

export const backgroundVideos: BackgroundVideoType[] = [
  { name: 'a', videoSrc: video_a, imgSrc: img_a },
  { name: 'b', videoSrc: video_b, imgSrc: img_b },
  { name: 'c', videoSrc: video_c, imgSrc: img_c },
]
